import styled from 'styled-components';

// Utils
import { Link } from 'react-router-dom';

export const User = styled.div`
  position: relative;
  color: var(--blue100);
  display: flex;
  align-items: center;
  cursor: pointer;
  z-index: 5;
`;

export const IconWrap = styled.div`
  .icon {
    fill: none;
    stroke: var(--blue100);
    font-size: 20px;
    stroke-width: 1.5px;
  }
`;

export const Name = styled.div`
  font-size: 13px;
  line-height: 1.54em;
  font-weight: 600;
  letter-spacing: -0.03em;
  margin-left: 9px;
  color: var(--blue100);

  @media (max-width: 1170px) {
    display: none;
  }

  @media (max-width: 767px) {
    display: block;
    margin-left: 22px;
  }
`;

export const Dropdown = styled.div`
  display: none;
  position: absolute;
  top: 37px;
  right: 0;
  background: var(--white);
  border: 1px solid var(--aluminium35);
  box-sizing: border-box;
  box-shadow: 0px 3px 18px rgba(0, 0, 0, 0.04);
  border-radius: 4px;
  cursor: default;
  z-index: 1;
  min-width: 194px;

  @media (max-width: 767px) {
    right: auto;
    left: 0;
  }
`;

export const Header = styled.div`
  padding: 13px 24px;
  background: var(--aluminium10);
  color: var(--carbone70);
  font-weight: 600;
  display: block;
`;

export const HeaderName = styled.div`
  font-size: 15px;
  line-height: 1.33em;
`;

export const Email = styled.div``;

export const LogoutLink = styled.div`
  font-size: 15px;
  line-height: 1.6em;
  font-weight: 600;
  color: var(--red100);
  padding: 12px 25px;
  cursor: pointer;
  margin-bottom: 5px;
  transition: var(--transition);

  &:hover {
    color: var(--red120);
  }
`;

export const Overlay = styled.div`
  position: absolute;
  top: -20px;
  left: -20px;
  right: -20px;
  bottom: -20px;
`;

export const Title = styled.div`
  z-index: 1;
  display: flex;
  align-items: center;
`;

export const ExtUser = styled(User)`
  &:hover {
    ${Dropdown} {
      display: block;
    }
  }
`;

export const Nav = styled.ul`
  list-style: none;
  padding: 12px 0;
  margin: 0;
`;

export const NavItem = styled.li``;

export const NavLink = styled(Link)`
  font-family: var(--primary-font), sans-serif;
  color: var(--carbone100);
  font-size: 15px;
  line-height: 1.33em;
  padding: 8.5px 25px;
  display: block;

  &:hover {
    color: var(--theme-palette-brand-color);
  }
`;

export const Divider = styled.div`
  margin: -1px 25px 6px;
  border-bottom: 1px solid var(--aluminium60);
`;
